import { Col, Row } from "antd";
import { t } from "i18next";
import React, { useContext } from "react";

import { MinistryContext } from "../../../../../../../../modules/ministry/ministry.context";
import { IDokumentiIzPoreskeProps } from "../../../../../../../../modules/ministry/ministry.types";
import { DocumentReadOnly } from "../../../../../../components/Documentation/components/DocumentReadOnly/DocumentReadOnly";
import style from "./Taxes.module.scss";

interface ITaxesProps {
  dozvolaZahtevId: number | null;
  dokumentiPoreska: IDokumentiIzPoreskeProps[];
}

export const Taxes: React.FC<ITaxesProps> = ({
  dozvolaZahtevId,
  dokumentiPoreska,
}) => {
  const { ministry } = useContext(MinistryContext);

  const getDokumentName = (naziv: string) => {
    if (ministry.detaljiODozvoli?.evidencioniBroj && naziv) {
      return `${ministry.detaljiODozvoli?.evidencioniBroj}-${naziv}`;
    }
    return naziv;
  };

  return (
    <Col className={style.mainContainer}>
      <Col className="pb-40 textBold" span={24}>
        <span className={style.fontSize}>{t("AKCIZNE_DOZVOLE.PORESKA")}</span>
      </Col>
      <Col span={24}>
        <Row className="pl-20 pb-20 spaceBetween">
          <Col span={6}>
            <span className={style.fontSize}>
              {t("AKCIZNE_DOZVOLE.ZAPISNIK")}
            </span>
          </Col>
        </Row>
        {ministry.detaljiODozvoli.misljenjePoreske && (
          <Row className="pl-20 pb-20 spaceBetween">
            <Col span={24}>
              <div className={style.prekidVazenjaNote}>
                {ministry.detaljiODozvoli.misljenjePoreske}
              </div>
            </Col>
          </Row>
        )}
        <Row className="pl-20 w-100 pb-20 spaceBetween">
          <Col span={8}>
            {dokumentiPoreska.map((dokument: IDokumentiIzPoreskeProps) => {
              return (
                <DocumentReadOnly
                  tip={1}
                  dozvolaZahtevId={dozvolaZahtevId}
                  tipDokumentaId={dokument.tipDokumentaId}
                  data={{
                    id: 1,
                    tip: 1,
                    dokumentUrl: dokument.naziv,
                    vrednostUslova: true,
                  }}
                  disabled
                  title={""}
                  dokumentName={getDokumentName(dokument?.naziv)}
                  isPoreska
                />
              );
            })}
          </Col>
        </Row>
      </Col>
    </Col>
  );
};
